const categoryTopics = {
  "en": {
    OO10: "onlyoffice_10_0",
    OO16thAnniversary: "onlyoffice-16th-anniversary",
    productReleases: "product-releases",
    forDevelopers: "for-developers",
    forBusiness: "for-business",
  },
  "fr": {
    OO10: "onlyoffice_10_0-fr",
    OO16thAnniversary: "16e-anniversaire-donlyoffice",
    productReleases: "mises-a-jour-des-produits-fr",
    forDevelopers: "pour-les-developpeurs-fr",
    forBusiness: "pour-les-entreprises-fr",
  },
  "de": {
    OO10: "onlyoffice_10_0-de",
    OO16thAnniversary: "onlyoffice-16-geburtstag",
    productReleases: "veroeffentlichungen",
    forDevelopers: "entwicklung",
    forBusiness: "business",
  },
  "es": {
    OO10: "onlyoffice_10_0-es",
    OO16thAnniversary: "16o-aniversario-de-onlyoffice",
    productReleases: "lanzamientos-de-productos",
    forDevelopers: "para-desarrolladores",
    forBusiness: "para-empresas",
  },
  "pt-br": {
    OO10: "onlyoffice_10_0-pt-br",
    OO16thAnniversary: "16o-aniversario-do-onlyoffice",
    productReleases: "lancamentos-de-produtos",
    forDevelopers: "para-desenvolvedores",
    forBusiness: "para-negocios",
  },
  "it": {
    OO10: "onlyoffice_10_0-it",
    OO16thAnniversary: "onlyoffice-compie-16-anni",
    productReleases: "rilascio-dei-prodotti",
    forDevelopers: "per-gli-sviluppatori",
    forBusiness: "per-affari",
  },
  "cs": {
    OO10: "onlyoffice_10_0-cs",
    forBusiness: "pro-firmy",
  },
  "ja": {
    OO10: "onlyoffice_10_0-ja",
    OO16thAnniversary: "onlyoffice-16th-anniversary-ja",
    productReleases: "product-releases-ja",
    forDevelopers: "for-developers-ja",
    forBusiness: "for-business-ja",
  },
  "zh-hans": {
    OO10: "onlyoffice_10_0-zh-hans",
    OO16thAnniversary: "onlyoffice-16-zhounian-qing",
    productReleases: "product-releases-zh-hans",
    forDevelopers: "for-developers-zh-hans",
    forBusiness: "for-business-zh-hans",
  },
  "el": {
    OO10: "onlyoffice_10_0-el",
    OO16thAnniversary: "16i-epeteios-onlyoffice",
    productReleases: "product-releases-el",
    forDevelopers: "for-developers-el",
    forBusiness: "for-business-el",
  },
  "hi": {
    OO10: "onlyoffice_10_0-hi",
    productReleases: "product-releases-hi",
    forDevelopers: "for-developers-hi",
    forBusiness: "for-business-hi",
  },
  "ar": {
    OO10: "onlyoffice_10_0-ar",
    OO16thAnniversary: "16-aldhikra-alsanawiya-onlyoffice",
    productReleases: "product-releases",
    forDevelopers: "for-developers",
    forBusiness: "for-business",
  },
  "sr": {
    OO10: "onlyoffice_10_0-sr",
    OO16thAnniversary: "16-godisnjica-onlyoffice-a",
    productReleases: "product-releases-sr",
    forDevelopers: "for-developers-sr",
    forBusiness: "for-business-sr",
  },
  "hy": {
    OO10: "onlyoffice_10_0-hy",
    productReleases: "product-releases-hy",
    forDevelopers: "for-developers-hy",
    forBusiness: "for-business-hy",
  },
};

export default categoryTopics;
